import React from "react";
import { AddMasterInvestmentContainer } from "../../../containers";

const AddInvestment = (props) => {
  return <AddMasterInvestmentContainer {...props} />;
};

export default AddInvestment;
